"use strict";

exports.__esModule = true;
exports["default"] = returnFalse;

function returnFalse() {
    return false;
}

module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./~/react-custom-scrollbars/lib/utils/returnFalse.js
// module id = 218
// module chunks = 0 1 9